import {
  decimal,
  greaterThanEqualTo,
  requiredAllowZero,
  Validator
} from '@sequencehq/utils/validation'

// What a customer pays for a grant. Zero is a valid price: the credit is free.
// Only the first failure is shown, so the sign is checked before the decimals:
// otherwise "-5" reads as a decimal-places error.
export const GRANT_PRICE_VALIDATORS: Validator[] = [
  requiredAllowZero,
  greaterThanEqualTo(0, 'Price cannot be negative'),
  decimal('2')
]
